import { call, select } from "redux-saga/effects";

import { Deal } from "@mapmycustomers/shared/types/entity";
import Organization from "@mapmycustomers/shared/types/Organization";

import OpenStageDealAmountCardData from "@app/scene/dashboard/store/cards/openStageDealAmount/OpenStageDealAmountCardData";
import { callApi } from "@app/store/api/callApi";
import { getOrganizationId } from "@app/store/iam";
import DealRottingCriteriaOptions from "@app/types/dashboard/cards/openStageDealAmount/DealRottingCriteriaOptions";
import OpenStageDealAmountCardConfiguration from "@app/types/dashboard/cards/openStageDealAmount/OpenStageDealAmountCardConfiguration";
import Scope from "@app/types/dashboard/Scope";
import AggregatedListResponse from "@app/types/viewModel/AggregatedListResponse";
import { parseValue } from "@app/util/viewModel/converters/parseIntervalCondition";

export function* fetchOpenStageDealAmountCardDataHelper(params: {
  callback: (data: OpenStageDealAmountCardData) => void;
  configuration: OpenStageDealAmountCardConfiguration;
  scope?: Scope;
}) {
  const { callback, configuration, scope } = params;
  const { criteria, dateRange, extraFilters } = configuration;

  const orgId: Organization["id"] = yield select(getOrganizationId);
  const parsedValue = typeof dateRange.days === "string" ? parseValue(dateRange.days) : undefined;
  const filters = {
    ...extraFilters,
    $and: [
      ...(dateRange.days
        ? [
            {
              closingDate: {
                $interval: parsedValue
                  ? {
                      $gte: `${parsedValue.amount} ${parsedValue.unit}`,
                      $lt: `${parsedValue.amount + 1} ${parsedValue.unit}`,
                      $round: parsedValue.unit,
                    }
                  : {
                      $gte: "0 days",
                      $lt: `${dateRange.days} days`,
                      $round: "days",
                    },
              },
            },
          ]
        : []),
      ...(criteria.rottingOptions.length === 2 || criteria.rottingOptions.length === 0
        ? []
        : [
            {
              rottingDaysOut: criteria.rottingOptions.includes(
                DealRottingCriteriaOptions.DEALS_ROTTING
              )
                ? { $gt: 0 }
                : { $lt: 0 },
            },
          ]),
      { stageId: { $in: criteria.dealStageIds } },
      ...(scope?.teamId ? [{ teamId: { $in: [scope.teamId] } }] : []),
      ...(scope?.userId ? [{ userId: { $in: [scope.userId] } }] : []),
    ],
  };

  const payload = {
    $aggs: { sum: ["amount"] },
    $filters: filters,
    $limit: 0,
  };

  const response: AggregatedListResponse<Deal> = yield callApi("fetchDeals", orgId, payload);

  const result: OpenStageDealAmountCardData = { amount: response.aggregations.sum_amount.value };

  yield call(callback, result);
}
